import LoginModal from './Login'
import Subscriptions from './Subscriptions'
import { useAnnualPlan } from '../../hooks/featureFlags'
import { useState } from 'react'

const UpgradeModals = ({
	subscriptionModalOpen,
	loginModalOpen,
	setSubscriptionModalOpen,
	setLoginModalOpen,
	premiumPath,
	noMoreCredits = false,
	context,
	unlockEssay,
	onClose,
}: {
	subscriptionModalOpen: boolean
	loginModalOpen: boolean
	setSubscriptionModalOpen: (open: boolean) => void
	setLoginModalOpen: (open: boolean) => void
	premiumPath?: boolean
	noMoreCredits?: boolean
	unlockEssay?: boolean
	context: string
	onClose?: () => void
}) => {
	const [checkoutStep, setCheckoutStep] = useState<'selector' | 'checkout' | 'success'>('selector')
	const [annualPlan, setAnnualPlan] = useAnnualPlan()

	return (
		<>
			<Subscriptions
				open={subscriptionModalOpen}
				setOpen={(open: boolean) => setSubscriptionModalOpen(open)}
				setLoginModal={(open: boolean) => {
					setLoginModalOpen(open)
				}}
				annualPlan={annualPlan}
				checkoutStep={checkoutStep}
				setCheckoutStep={setCheckoutStep}
				noMoreCredits={noMoreCredits}
				onClose={() => {
					onClose?.()
				}}
				unlockEssay={unlockEssay}
			/>
			<LoginModal
				premiumPath={premiumPath}
				open={loginModalOpen}
				setModalOpen={(open: boolean) => {
					setLoginModalOpen(open)
				}}
				annualPlan={annualPlan}
				setSubscriptionModalOpen={setSubscriptionModalOpen}
				context={context}
			/>
		</>
	)
}

export default UpgradeModals
